module.exports = __webpack_public_path__ + "img/trash.64ab7a19.svg";